import React from "react";

const FacebookIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8034_6857)">
      <rect
        width="24"
        height="24"
        transform="translate(0 0.407715)"
        fill="#1877F2"
      />
      <path
        d="M23.5 12.4776C23.5 6.12632 18.3513 0.977594 12 0.977594C5.64872 0.977594 0.5 6.12632 0.5 12.4776C0.5 18.2176 4.70538 22.9752 10.2031 23.8379V15.8018H7.2832V12.4776H10.2031V9.944C10.2031 7.06181 11.92 5.46978 14.5468 5.46978C15.805 5.46978 17.1211 5.69439 17.1211 5.69439V8.52447H15.671C14.2424 8.52447 13.7969 9.41094 13.7969 10.3204V12.4776H16.9863L16.4765 15.8018H13.7969V23.8379C19.2946 22.9752 23.5 18.2176 23.5 12.4776Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8034_6857">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.407715)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FacebookIcon;
